import { ResourceType } from '../../constants'

const resourceTypeToDisplayText: Record<ResourceType, string> = {
  [ResourceType.CABIN]: 'common.label.resource.cabins',
  [ResourceType.CONSULTANT]: 'common.label.resource.consultants',
  [ResourceType.CUSTOMER_SUPPORT]: 'common.label.resource.customerSupport',
  [ResourceType.FITTER]: 'common.label.resource.externalProviders',
  [ResourceType.FITTER_INTERNAL]: 'common.label.resource.internalProviders',
  [ResourceType.VIDEO_CARE_CALL_SPECIALIST]: 'common.label.resource.vccSpecialists',
}

export { resourceTypeToDisplayText }
